import { EXPORT_AUDIT_LOGS_API, SEARCH_AUDIT_LOGS_API } from '~/constants/APIs/auditLogs'
import { IAuditLogsSearchRequest, IAuditLogsSearchResponse } from '~/models'
import axiosClient from './axiosClient'

export const auditLogApis = {
  searchAuditLogs: (params: IAuditLogsSearchRequest | null) =>
    axiosClient.get(SEARCH_AUDIT_LOGS_API, {
      params
    }) as unknown as IAuditLogsSearchResponse,

  exportAuditLogs: (data: IAuditLogsSearchRequest | null) =>
    axiosClient.get(EXPORT_AUDIT_LOGS_API, {
      params: {
        searchTerms: data?.searchTerms,
        fromDate: data?.fromDate,
        toDate: data?.toDate,
        downloadId: 'string'
      },
      headers: {
        'Content-Type': 'application/json'
      },
      responseType: 'blob'
    })
}
